import { LayerType } from './game';
import { LAYER_IMAGES, RACE_CONFIG, COLOR_CONFIG } from '../lib/gameConstants';

export type LayerName =
  | 'layer_background'
  | 'layer_body'
  | 'layer_skin'
  | 'layer_eyes'
  | 'layer_tattoo'
  | 'layer_outfit'
  | 'layer_frame'
  | 'layer_armor'
  | 'layer_weapon'
  | 'layer_shield'
  | 'layer_accessory';

export type BaseLayerName =
  | 'layer_background'
  | 'layer_body'
  | 'layer_skin'
  | 'layer_eyes'
  | 'layer_tattoo'
  | 'layer_outfit'
  | 'layer_frame';

export type EquipmentLayerName =
  | 'layer_armor'
  | 'layer_weapon'
  | 'layer_shield'
  | 'layer_accessory';

export interface CharacterLayerUrls {
  layer_background_url?: string;
  layer_body_url?: string;
  layer_skin_url?: string;
  layer_eyes_url?: string;
  layer_tattoo_url?: string;
  layer_outfit_url?: string;
  layer_frame_url?: string;
  layer_armor_url?: string;
  layer_weapon_url?: string;
  layer_shield_url?: string;
  layer_accessory_url?: string;
}

export const FALLBACK_LAYER_CONFIG: LayerType[] = [
  { id: 'layer_background', name: 'layer_background', display_name: '背景', layer_order: 1 },
  { id: 'layer_body', name: 'layer_body', display_name: '身體', layer_order: 2 },
  { id: 'layer_skin', name: 'layer_skin', display_name: '皮膚', layer_order: 3 },
  { id: 'layer_eyes', name: 'layer_eyes', display_name: '眼睛', layer_order: 4 },
  { id: 'layer_tattoo', name: 'layer_tattoo', display_name: '刺青', layer_order: 5 },
  { id: 'layer_outfit', name: 'layer_outfit', display_name: '服裝', layer_order: 6 },
  { id: 'layer_frame', name: 'layer_frame', display_name: '邊框', layer_order: 7 },
  { id: 'layer_armor', name: 'layer_armor', display_name: '護甲', layer_order: 8 },
  { id: 'layer_weapon', name: 'layer_weapon', display_name: '武器', layer_order: 9 },
  { id: 'layer_shield', name: 'layer_shield', display_name: '盾牌', layer_order: 10 },
  { id: 'layer_accessory', name: 'layer_accessory', display_name: '飾品', layer_order: 11 },
];

export const REQUIRED_LAYERS: Set<LayerName> = new Set([
  'layer_skin',
  'layer_eyes',
  'layer_outfit',
  'layer_frame'
]);

export const OPTIONAL_LAYERS: Set<LayerName> = new Set([
  'layer_background',
  'layer_body',
  'layer_tattoo',
  'layer_armor',
  'layer_weapon',
  'layer_shield',
  'layer_accessory'
]);

export const EQUIPMENT_LAYERS: Set<LayerName> = new Set([
  'layer_armor',
  'layer_weapon',
  'layer_shield',
  'layer_accessory'
]);
